import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import { imageUrl } from '../lib/images'

export default function News() {
  return (
    <div>
      <PageHeader
        badge="Nyheder & Presse"
        title="Nyheder fra Unges Fremtid"
        subtitle="Læs om foreningens stiftelse, målrettede indsatser og nye initiativer for sårbare og udsatte børn og unge."
        breadcrumb={[{ label: 'Nyheder' }]}
      />

      {/* SEKTION 6: NYHEDER (Foto: Logo) */}
      <section className="py-16 sm:py-24 bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <article className="space-y-8">
            {/* Header info */}
            <div className="space-y-4 border-b border-neutral-200 pb-8">
              <div className="flex flex-wrap items-center gap-3">
                <span className="bg-amber-100 text-[#0c304d] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                  Officiel pressemeddelelse
                </span>
                <span className="text-neutral-500 text-sm flex items-center gap-1.5">
                  <i className="fa-regular fa-calendar" aria-hidden="true" />
                  <span>7. august 2026</span>
                </span>
                <span className="text-neutral-500 text-sm flex items-center gap-1.5">
                  <i className="fa-solid fa-location-dot text-[#f39223]" aria-hidden="true" />
                  <span>Landsdækkende • Randers SØ</span>
                </span>
              </div>

              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0c304d] tracking-tight leading-tight">
                Ny forening vil hjælpe udsatte unge på vej mod det gode liv
              </h1>

              <p className="text-lg sm:text-xl text-neutral-700 leading-relaxed font-medium">
                Den nystiftede landsdækkende forening Unges Fremtid vil skabe nye muligheder for sårbare og udsatte unge mellem 10 og 29 år. Gennem blandt andet mentorindsatser, frivillige fællesskaber og samarbejde med kommuner, virksomheder og uddannelsesinstitutioner skal flere unge hjælpes til trivsel, uddannelse og beskæftigelse.
              </p>
            </div>

            {/* Billede: Logo */}
            <div className="w-fit h-fit ml-0 p-8 sm:p-12 rounded-3xl bg-[#faf9f6] border border-neutral-200 flex items-center justify-center shadow-xs">
              <img
                src={imageUrl('/_assets/unges-fremtid-logo.png', 'width=800,quality=90,format=auto')}
                alt="Unges Fremtid Logo"
                className="max-h-36 sm:max-h-48 w-auto object-contain"
                width={400}
                height={180}
              />
            </div>

            {/* Brødtekst */}
            <div className="prose max-w-none text-neutral-700 space-y-6 text-base sm:text-lg leading-relaxed">
              <p>
                Alt for mange unge oplever i dag ensomhed, mistrivsel, skolefravær, marginalisering eller vanskeligheder med at finde vej ind i uddannelse og arbejdsliv. Det vil den nye almennyttige non-profit forening Unges Fremtid være med til at gøre noget ved.
              </p>
              <p>
                Foreningen blev stiftet den 7. august 2026 som en upolitisk og ikke-religiøs humanitær organisation med ét overordnet mål: at hjælpe sårbare og udsatte unge mellem 10 og 29 år på vej mod et godt og meningsfuldt liv.
              </p>
              <p>
                Unges Fremtid vil tage udgangspunkt i den enkelte unges ressourcer og muligheder og arbejde for at udvikle de personlige, sociale, kulturelle, sproglige og faglige kompetencer, der kan være afgørende for at komme videre i livet.
              </p>

              <h2 className="text-2xl sm:text-3xl font-extrabold text-[#0c304d] pt-4">
                Fra mistrivsel til nye muligheder
              </h2>
              <p>
                Foreningen vil blandt andet arbejde for at styrke unges trivsel og livsmestring, forebygge ensomhed, marginalisering og kriminalitet samt støtte unge i at gennemføre en uddannelse og komme i beskæftigelse eller anden meningsfuld aktivitet.
              </p>
              <p>
                Et centralt element bliver udviklingen af mentorordninger, frivillige netværk og fællesskaber, hvor unge kan møde voksne og andre rollemodeller, der har tid, overskud og lyst til at gøre en forskel.
              </p>
              <p>
                Samtidig ønsker Unges Fremtid at bygge bro mellem civilsamfundet, kommunerne, virksomhederne og uddannelsesinstitutionerne.
              </p>
              <p>
                Ambitionen er, at forskellige kræfter i samfundet i højere grad arbejder sammen om at skabe konkrete muligheder for de unge, der har brug for en ekstra hånd på vejen.
              </p>

              <h2 className="text-2xl sm:text-3xl font-extrabold text-[#0c304d] pt-4">
                Indsatser i hele Danmark
              </h2>
              <p>
                Unges Fremtid vil udvikle og gennemføre projekter og programmer over hele landet. Det kan blandt andet være mentor- og frivilligindsatser, undervisnings- og udviklingsprojekter, kurser, konferencer og samarbejdsprojekter med offentlige og private aktører.
              </p>
              <p>
                Foreningen vil desuden indsamle og formidle viden om indsatser, der virker, så erfaringer og gode metoder kan komme endnu flere unge til gavn.
              </p>
              <p>
                Arbejdet skal finansieres gennem blandt andet fonde, puljer, donationer, sponsorater, partnerskaber, indsamlinger og andre aktiviteter. Alle midler og aktiviteter skal understøtte foreningens almennyttige formål.
              </p>

              <div className="my-8 p-6 sm:p-8 bg-amber-50/90 rounded-3xl border border-amber-200/90 space-y-4">
                <h3 className="text-2xl font-bold text-[#0c304d]">
                  En fælles opgave
                </h3>
                <p>
                  Grundtanken bag Unges Fremtid er enkel: Et ungt menneskes fremtid bør ikke afgøres af, om det på et afgørende tidspunkt i livet mangler støtte, netværk eller en voksen, der tror på det.
                </p>
                <p>
                  Nogle gange skal der ikke meget til for at skabe en stor forandring. Den rigtige relation, en mentor, et fællesskab, en praktikplads eller en person, der åbner en dør, kan blive begyndelsen på en helt ny retning.
                </p>
                <p className="font-extrabold text-[#f39223] text-xl">
                  Unges Fremtid vil være med til at åbne de døre.
                </p>
              </div>
            </div>

            {/* Deling og kontakt CTA */}
            <div className="pt-8 border-t border-neutral-200 flex flex-col sm:flex-row items-center justify-between gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 bg-[#f39223] hover:bg-[#e08112] text-white font-semibold text-sm px-7 py-3 rounded-full transition-colors cursor-pointer shadow-xs"
              >
                <i className="fa-solid fa-paper-plane text-xs" aria-hidden="true" />
                <span>Kontakt organisationen</span>
              </Link>

              <div className="text-neutral-500 text-sm">
                Spørgsmål til presse? Skriv til <a href="mailto:ungesfremtid@outlook.dk" className="text-[#0c304d] font-semibold underline">ungesfremtid@outlook.dk</a>
              </div>
            </div>
          </article>
        </div>
      </section>
    </div>
  )
}
